import React from 'react';
import Chip from '@mui/material/Chip';
import { ASSESSMENT_STATUSES } from '../../utils/constants';

export default function StatusChip({ status, size = 'small' }) {
  const config = ASSESSMENT_STATUSES[status];
  const label = config?.label || status?.replace(/_/g, ' ') || 'Unknown';
  const color = config?.color || '#6b7280';

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: `${color}18`,
        color: color,
        fontWeight: 600,
        borderColor: `${color}40`,
        border: '1px solid',
      }}
    />
  );
}
